/* CF山梨: お問い合わせ(Step10)演出
   - (1) .cf-reveal をスクロールに合わせて静かにフェードアップ
   - (2) ヒーロー: 見出しを1文字ずつ表示(cf-about のヒーロー部品を踏襲)+背景パララックス
   - (3) フォームアプリ使用時のボット対策(ハニーポット+送信までの時間チェック)
   - 安全策: JSがルートに data-cf-anim を付けたときだけCSSが要素を隠す。
     分割や演出が失敗しても catch で即表示に倒す。
     JS無効・JSエラー・古いブラウザでは内容は常時表示(消えない)
   - prefers-reduced-motion を尊重(演出オフ=常時表示・パララックスなし)
   - 二重初期化をガード */
(function () {
  if (window.__cfContactFxInit) return;
  window.__cfContactFxInit = true;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* 文字分割: 1文字ずつ span.cf-char に包む。英数字の連続は span.cf-word で改行禁止に。
     元テキストは aria-label で保持する */
  function splitChars(el) {
    var text = el.textContent;
    var chars = Array.from(text);
    var wrap = document.createElement('span');
    wrap.className = 'cf-chars';
    wrap.setAttribute('aria-hidden', 'true');
    var made = [];
    var word = null;
    for (var i = 0; i < chars.length; i++) {
      var ch = chars[i];
      var target = wrap;
      if (/[A-Za-z0-9]/.test(ch)) {
        if (!word) {
          word = document.createElement('span');
          word.className = 'cf-word';
          wrap.appendChild(word);
        }
        target = word;
      } else {
        word = null;
      }
      var s = document.createElement('span');
      s.className = 'cf-char';
      s.textContent = ch === ' ' ? ' ' : ch;
      made.push(s);
      target.appendChild(s);
    }
    el.setAttribute('aria-label', text);
    el.textContent = '';
    el.appendChild(wrap);
    return made;
  }

  /* (1) スクロールフェードアップ */
  function setupReveal(root) {
    if (reduce || !hasIO) return;
    var items = root.querySelectorAll('.cf-reveal');
    if (!items.length) return;
    root.setAttribute('data-cf-anim', '');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i, 4) * 80 + 'ms';
      io.observe(el);
    });
  }

  /* (2a) ヒーロー: 見出しの1文字ずつ表示(読み込み直後に発火) */
  function setupHero(root) {
    if (reduce || !hasIO) return;
    var hero = root.querySelector('.cf-contact-hero');
    if (!hero) return;
    try {
      var delay = 250;
      var step = 55;
      hero.querySelectorAll('[data-cf-chars]').forEach(function (el) {
        var spans = splitChars(el);
        spans.forEach(function (s) {
          s.style.transitionDelay = delay + 'ms';
          delay += step;
        });
        delay += 200;
      });
      hero.style.setProperty('--cf-body-delay', delay + 100 + 'ms');
      root.setAttribute('data-cf-anim', '');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          hero.classList.add('is-in');
        });
      });
    } catch (e) {
      hero.classList.add('is-in');
    }
  }

  /* (2b) ヒーローのパララックス(PCのみ・背景がゆっくり追いかける) */
  function setupParallax(root) {
    if (reduce) return;
    var hero = root.querySelector('.cf-contact-hero');
    var media = hero && hero.querySelector('.cf-contact-hero__media');
    if (!media) return;
    var ticking = false;
    function update() {
      ticking = false;
      if (window.innerWidth < 750) {
        media.style.transform = '';
        return;
      }
      var rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var shift = Math.min(Math.max(-rect.top, 0) * 0.16, rect.height * 0.14);
      media.style.transform = 'translateY(' + shift.toFixed(1) + 'px)';
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* (3) フォームアプリ(Powerful Form Builder)の画面側ボット対策(2026-09-11)
     - アプリ側の reCAPTCHA v3 に重ねる。アプリにはハニーポット機能がないため、ここで実装する
     - ハニーポット: 人には見えない入力欄を差し込み、値が入っていたら黙って送信を止める。
       name を付けないのでアプリへは送られず、通知メールにも出ない
     - 送信までの時間: 表示から3秒未満の送信は1回だけ止めて案内を出す(人は次の送信で通る)
     - アプリの描画を待ってから仕掛ける。フォームが見つからなければ何もしない(送信を妨げない側に倒す)
     - アプリは読み込み後にフォームを描き直すことがあるため、差し込んだ欄が消えたら毎回入れ直す */
  function setupAppFormGuard(root) {
    var host = root.querySelector('[data-cf-app-form] .globo-formbuilder');
    if (!host) return;
    var MIN_MS = 3000;
    var shownAt = 0;
    var armed = false;

    function ensureHp() {
      var form = host.querySelector('form');
      if (!form) return false;
      if (!armed) {
        armed = true;
        shownAt = Date.now();
      }
      if (form.querySelector('[data-cf-hp]')) return true;
      var wrap = document.createElement('div');
      wrap.className = 'cf-hp';
      wrap.setAttribute('aria-hidden', 'true');
      var hp = document.createElement('input');
      hp.type = 'text';
      hp.tabIndex = -1;
      hp.setAttribute('autocomplete', 'off');
      hp.setAttribute('data-cf-hp', '');
      wrap.appendChild(hp);
      form.insertBefore(wrap, form.firstChild);
      return true;
    }

    function showNote(text) {
      var box = host.parentNode.querySelector('.cf-contact-form__guard');
      if (!box) {
        box = document.createElement('p');
        box.className = 'cf-contact-form__guard';
        box.setAttribute('role', 'alert');
        host.insertAdjacentElement('afterend', box);
      }
      box.textContent = text;
    }

    function guard(e) {
      if (!armed) return;
      var form = host.querySelector('form');
      var t = e.target;
      if (!form || !t || !t.closest || !form.contains(t)) return;
      if (e.type === 'click' && !t.closest('button[type="submit"]')) return;
      var hp = form.querySelector('[data-cf-hp]');
      if (hp && hp.value) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      if (shownAt && Date.now() - shownAt < MIN_MS) {
        e.preventDefault();
        e.stopImmediatePropagation();
        shownAt = 0;
        showNote('送信前に入力内容をご確認のうえ、もう一度送信ボタンを押してください。');
        return;
      }
      /* 通す送信では、前に出した案内を消す(送信完了後に残らないように) */
      var old = host.parentNode.querySelector('.cf-contact-form__guard');
      if (old) old.parentNode.removeChild(old);
    }
    /* window の捕捉段階で受けて、アプリの送信処理より先に判定する */
    window.addEventListener('click', guard, true);
    window.addEventListener('submit', guard, true);

    ensureHp();
    if ('MutationObserver' in window) {
      new MutationObserver(ensureHp).observe(host, { childList: true, subtree: true });
    }
  }

  function boot() {
    var root = document.querySelector('.cf-contact');
    if (!root) return;
    setupReveal(root);
    setupHero(root);
    setupParallax(root);
    try {
      setupAppFormGuard(root);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
